import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end align-items-start" }
const _hoisted_2 = {
  id: "table-container",
  style: {"background-color":"lightgray"}
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center h-100 p-5"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex flex-column justify-content-between h-100"
}
const _hoisted_5 = { class: "text-center my-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-center my-1"
}
const _hoisted_7 = {
  key: 1,
  class: "text-center"
}
const _hoisted_8 = { class: "text-danger my-1" }
const _hoisted_9 = {
  key: 0,
  class: "multiselect__single"
}
const _hoisted_10 = {
  key: 1,
  class: "multiselect__single"
}
const _hoisted_11 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_button = _resolveComponent("b-button")
  const _component_b_spinner = _resolveComponent("b-spinner")
  const _component_b_form_input = _resolveComponent("b-form-input")
  const _component_v_multiselect = _resolveComponent("v-multiselect")
  const _component_b_table = _resolveComponent("b-table")

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_b_button, {
        title: "Alle Filter zurücksetzen",
        class: _normalizeClass({'text-nowrap': true, invisible: !$props.department}),
        style: {"margin-bottom":"0.5rem"},
        onClick: _cache[0] || (_cache[0] = $event => ($options.resetFilters()))
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
          _createElementVNode("i", { class: "fas fa-filter" }, null, -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class"])
    ], 512 /* NEED_PATCH */), [
      [_vShow, $props.department]
    ]),
    _createElementVNode("div", _hoisted_2, [
      (!$props.department)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Klicken Sie auf Details für eine Übersicht der bestellten Artikel der jeweiligen Abteilung. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_b_table, {
              ref: "table",
              busy: $data.busy,
              "onUpdate:busy": _cache[4] || (_cache[4] = $event => (($data.busy) = $event)),
              fields: $data.fields,
              items: $options.filteredItems,
              class: "bootstrap-vue-table-borders",
              striped: "",
              "head-variant": "light",
              "sticky-header": "100%",
              "show-empty": "",
              "primary-key": "id",
              "sort-by": [{key: 'invoiceDate', order: 'asc'}]
            }, {
              "table-busy": _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_b_spinner, {
                    small: "",
                    type: "grow",
                    variant: "secondary"
                  }),
                  _createVNode(_component_b_spinner, {
                    style: {"animation-delay":"0.1s"},
                    small: "",
                    type: "grow",
                    variant: "secondary"
                  }),
                  _createVNode(_component_b_spinner, {
                    style: {"animation-delay":"0.2s"},
                    small: "",
                    type: "grow",
                    variant: "secondary"
                  })
                ])
              ]),
              empty: _withCtx(() => [
                (!$data.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Keine passenden Ergebnisse gefunden. "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, " Ein Fehler ist aufgetreten (" + _toDisplayString($data.error.message) + "). ", 1 /* TEXT */)
                    ]))
              ]),
              "head()": _withCtx(({field}) => [
                _createElementVNode("div", null, _toDisplayString(field.label), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  (field.filter && (field.filter.type === 'string-contains'
                  || field.filter.type === 'decimal-number-contains'))
                    ? (_openBlock(), _createBlock(_component_b_form_input, {
                        key: 0,
                        modelValue: field.filter.value,
                        "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                        type: "text",
                        size: "sm",
                        placeholder: "Suchen...",
                        debounce: "200",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("v-if", true),
                  (field.filter && field.filter.type === 'string-equals')
                    ? (_openBlock(), _createBlock(_component_b_form_input, {
                        key: 1,
                        modelValue: field.filter.value,
                        "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                        type: "text",
                        size: "sm",
                        placeholder: "Gleich...",
                        debounce: "200",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("v-if", true),
                  (field.filter && field.filter.type === 'multiselect')
                    ? (_openBlock(), _createBlock(_component_v_multiselect, {
                        key: 2,
                        modelValue: field.filter.value,
                        "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                        options: field.filter.options || [],
                        multiple: true,
                        "track-by": "id",
                        label: "name",
                        "close-on-select": false,
                        "show-pointer": false,
                        "selected-label": "✓",
                        "open-direction": "bottom",
                        placeholder: "Filtern...",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        selection: _withCtx(({ values, isOpen }) => [
                          (values.length > 1 && !isOpen)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(values.length) + " Werte ", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (values.length === 1 && !isOpen)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(values[0].short || values[0].name), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        beforeList: _withCtx(() => [
                          _createElementVNode("li", {
                            class: "multiselect__option",
                            onClick: $event => (field.filter.value = [])
                          }, [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                            _createTextVNode(" Filter löschen ", -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_11),
                          _cache[7] || (_cache[7] = _createElementVNode("li", { class: "dropdown-divider" }, null, -1 /* CACHED */))
                        ]),
                        noResult: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode(" Keine Inhalte gefunden. ", -1 /* CACHED */)
                        ]))]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "options"]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["busy", "fields", "items"]),
            _cache[9] || (_cache[9] = _createElementVNode("div", {
              id: "deviation-note",
              class: "alert alert-warning rounded-0 border-end-0 border-start-0 mb-0",
              role: "alert"
            }, [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("i", {
                  class: "fas fa-exclamation-triangle me-3",
                  style: {"opacity":"0.6"}
                }),
                _createTextVNode(" Bitte beachten Sie, dass der angezeigte Gesamtpreis nur die voraussichtlichen Kosten widerspiegelt und vom tatsächlichen Rechnungspreis abweichen kann. ")
              ])
            ], -1 /* CACHED */))
          ]))
    ])
  ]))
}